import { render, staticRenderFns } from "./PaymentPadContent.vue?vue&type=template&id=40daf750&lang=pug"
import script from "./PaymentPadContent.vue?vue&type=script&lang=js"
export * from "./PaymentPadContent.vue?vue&type=script&lang=js"
import style0 from "./PaymentPadContent.vue?vue&type=style&index=0&id=40daf750&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports